import { Heading } from 'blaze-ui/Heading/Heading'
import { ContentCountField } from 'screens/Campaign/Overview/EditChannelsModal/ContentCountField'
import { CrosspostTactics } from 'screens/Campaign/Overview/EditChannelsModal/CrosspostTactics'
import Styles from './Crossposts.module.scss'
import { VideoCrosspostTactics } from 'screens/Campaign/Overview/EditChannelsModal/VideoCrosspostTactics'
import { StoriesCountField } from 'screens/Campaign/Overview/EditChannelsModal/StoriesCountField'
import { StoriesTactics } from 'screens/Campaign/Overview/EditChannelsModal/StoriesTactics'

export const Crossposts = () => {
  return (
    <div className={Styles.crossposts}>
      <Heading level={4}>How many posts would you like to publish, and on which channels?</Heading>
      <div className={Styles.fields}>
        <div className={Styles.crosspostField}>
          <div className={Styles.count}>
            <ContentCountField name="crosspost_contents.0" label="Crossposts" interval="week" />
          </div>
          <CrosspostTactics />
        </div>
        <div className={Styles.crosspostField}>
          <div className={Styles.count}>
            <ContentCountField name="video_crosspost_contents.0" label="Video crossposts" interval="week" />
          </div>
          <VideoCrosspostTactics />
        </div>
        <div className={Styles.crosspostField}>
          <div className={Styles.count}>
            <StoriesCountField name="instagram_contents" interval="week" />
          </div>
          <StoriesTactics name="instagram_contents" />
        </div>
      </div>
    </div>
  )
}
